import { createSelector } from '@reduxjs/toolkit';

import { projectSelector } from 'src/selectors/project';

export const projectPublishHistorySelector = (projectId: string) =>
  createSelector(
    projectSelector(projectId),
    (project) => project?.publishHistory || null
  );
